import { mediaQuery } from 'components';
import styled from 'styled-components';

export const CTAWrapper = styled.div`
  margin-bottom: 1rem;
`;

export const CartSideBarWrapper = styled.div`
  margin-bottom: 2rem;
  margin-top: 3rem;

  ${mediaQuery.medium`
    margin-top: 2rem;
  `}
`;